import { useState } from "react";

import { cn } from "./utils";

interface Props {
  imageUrl?: string | null;
  name: string;
  className?: string;
}

export function Avatar({ imageUrl, name, className }: Props) {
  const [isError, setIsError] = useState(false);

  if (!imageUrl || isError)
    return (
      <div
        className={cn(
          "w-8 h-8 rounded-full bg-gray-600 flex items-center justify-center aspect-square",
          className,
        )}
      >
        <span className="text-gray-300 lowercase">{name[0]}</span>
      </div>
    );
  return (
    <img
      src={imageUrl}
      alt={name}
      onError={() => setIsError(true)}
      className={cn(
        "w-8 h-8 rounded-full object-cover border border-white aspect-square",
        className,
      )}
    />
  );
}
